var _module_exports = "<a>\n  <b>{{ result.boldFullName }}</b>{{ result.normalPrefix }}<b>{{ result.boldSuffix }}</b>\n</a>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/typeaheadDropDown/tabCompletionResult.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;